<a [routerLink]="['/devices', 'unavailable']"
   class="btn btn-danger btn-sm rounded-pill ms-2 shadow-sm fw-bold ps-2 ps-xs-3 border-0">
  <span class="d-none d-sm-inline">Unavailable</span>
  <span class="ms-sm-1 badge text-bg-light rounded-pill">{{ count }}</span>
  <span class="visually-hidden">unavailable devices</span>
</a>